<template>
<div class="row clearfix">
  <div v-if="loading">
    <BlockUI :message="blockuimsg"></BlockUI>
  </div>
  <div class="col-lg-12">
    <b-row>
        <b-col style="text-align:center">
          <h3>Recursos / Enunciados</h3>
        </b-col>
    </b-row>
    <div class="card">
      <div class="tab-content">
        <div class="table-responsive">
          <div class="d-flex justify-content-between align-items-center mb-4 pl-4">
            <b-pagination class="p-0 m-0"
              v-model="currentPage"
              :total-rows="rows"
              :per-page="perPage"
              aria-controls="my-table">
            </b-pagination>
            <div class="d-flex align-items-center pl-3 mr-auto">
              <label class="p-0 m-0 pr-3 text-purple">Filtrar por tags</label>
              <vue-tags-input
                v-model="taglist"
                :autocomplete-items="tagslist"
                :add-only-from-autocomplete="true"
                @tags-changed="updatelist"
              />
            </div>
            <div class="col-md-3">
              <ResourceSearchs :routeApi="'statementmultiple'" ref="searchcomponent"
                :perPage = "perPage"
                :newTags2 = "newTags2"
                @update="onUpdateDataResource"
                @loading="onLoading"
              />
            </div>
            <b-button @click="onNew" variant="success">
              + Añadir
            </b-button>
          </div>
          <b-table hover :items="resources"
          :fields="fields"
          :per-page="0"
          :current-page="currentPage"
          >
           <template v-slot:cell(actions)="row">
            <b-button class="btn btn-icon btn-icon-mini btn-round btn-info" @click="info(row.item, row.index, $event.target)">
              <i class="zmdi zmdi-edit"></i>
            </b-button>
             <b-button class="btn btn-icon btn-icon-mini btn-round btn-danger" @click="ondelete(row.item)">
              <i class="fa fa-trash"></i>
            </b-button>
          </template>
          </b-table>
        </div>
      </div>
    </div>
  </div>
  <!-- Info modal -->
  <b-modal :id="infoModal.id" size="xl" :title="infoModal.title" hide-footer>
      <div class="modal-body">
        <ValidationObserver ref="formValidation">
        <b-row>

          <b-col>
          <div>
            <ValidationProvider :rules="{required: true}" v-slot="{ errors }">
              <label for="">Nombre</label>
              <b-form-input
                id="NOMBRE"
                v-model="selectedItem.NOMBRE"
                placeholder="Nombre..." />
              <span class="validation-error">{{ errors[0] }}</span>
            </ValidationProvider>
          </div>
          <br />
          <div>
            <ValidationProvider :rules="{required: true}" v-slot="{ errors }">
              <label>Texto del enunciado</label>
              <div class="col-md-12 d-inline-flex align-items-center p-0 m-0">
                <i class="zmdi zmdi-link pointer pr-2 text-primary"
                          v-if="selectedItem.TEXTOS_ID_ENUNCIADO !== null && selectedItem.TEXTOS_ID_ENUNCIADO !== 0"
                          @click="openResourceWithParam('texts', selectedItem.TEXTOS_ID_ENUNCIADO)"/>
                <input type="text" v-bind:value="getTranslation(selectedItem.text.TEXTO_ENUNCIADO)"
                  disabled class="form-control" />
                <searchtexts class="pl-2" idModal="mdlSearchTextEnunciado"
                  v-on:selected="onSelectedTextEnunciado($event)">
                </searchtexts>
              </div>
              <span class="validation-error">{{ errors[0] }}</span>
            </ValidationProvider>
          </div>
          <div>
            <label>Audio Enunciado</label>
            <div class="col-md-12 d-inline-flex align-items-center p-0 m-0">
              <i class="zmdi zmdi-link pointer pr-2 text-primary"
                        v-if="selectedItem.AUDIOS_ID !== null && selectedItem.AUDIOS_ID !== 0"
                        @click="openResourceWithParam('audios', selectedItem.AUDIOS_ID)"/>
              <i class="zmdi zmdi-close-circle pointer pr-2 text-danger" v-if="selectedItem.AUDIOS_ID !== 0 && selectedItem.AUDIOS_ID !== null" @click="cleanAudio()" />
              <audio :src="getTranslation(selectedItem.text.AUDIO_ENUNCIADO)" controls="controls"
                              style="width:100%" type="audio/mpeg" preload="preload" v-if="selectedItem.AUDIOS_ID !== 0 && selectedItem.AUDIOS_ID !== null">
              </audio>
              <span v-if="selectedItem.AUDIOS_ID === 0 || selectedItem.AUDIOS_ID === null">Sin audio</span>
              <searchaudios class="pl-2" idModal="mdlSearchAudio"
                v-on:selected="onSelectedAudio($event)">
              </searchaudios>
            </div>
          </div>
          <div>
            <label>Imagen Enunciado</label>
            <div class="col-md-12 d-inline-flex align-items-center p-0 m-0">
              <div class="image">
                <i class="zmdi zmdi-link pointer pr-2 text-primary"
                        v-if="selectedItem.IMAGENES_ID !== null && selectedItem.IMAGENES_ID !== 0"
                        @click="openResourceWithParam('images', selectedItem.IMAGENES_ID)"/>
                <i class="zmdi zmdi-close-circle pointer pr-2 text-danger" v-if="selectedItem.IMAGENES_ID !== 0 && selectedItem.IMAGENES_ID !== null" @click="cleanImage()" />
                    <img :src="getTranslation(selectedItem.text.IMAGEN_ENUNCIADO)" alt="img"
                    style="width:110px;height:110px" class="img-fluid">
              </div>
              <searchimages class="pl-2" idModal="mdlSearchImageEnunciado"
                v-on:selected="onSelectedImage($event)">
              </searchimages>
            </div>
          </div>
        </b-col>

        <b-col>
          <div>
            <ValidationProvider :rules="{required: true}" v-slot="{ errors }">
              <label>Respuesta Correcta</label>
              <div class="col-md-12 d-inline-flex align-items-center p-0 m-0">
                <i class="zmdi zmdi-link pointer pr-2 text-primary"
                          v-if="selectedItem.TEXTOS_ID_COR !== null && selectedItem.TEXTOS_ID_COR !== 0"
                          @click="openResourceWithParam('texts', selectedItem.TEXTOS_ID_COR)"/>
                <input type="text"  v-bind:value="getTranslation(selectedItem.responses.TEXTOS_EST_COR)"
                disabled class="form-control" />
                <searchtexts class="pl-2" idModal="mdlSearchTextResponse_Correcta"
                  v-on:selected="onSelectedTextResponse($event, 0)">
                </searchtexts>
              </div>
              <span class="validation-error">{{ errors[0] }}</span>
            </ValidationProvider>
          </div>
          <div>
            <ValidationProvider :rules="{required: true}" v-slot="{ errors }">
              <label>Respuesta erronea 1</label>
              <div class="col-md-12 d-inline-flex align-items-center p-0 m-0">
                <i class="zmdi zmdi-link pointer pr-2 text-primary"
                          v-if="selectedItem.TEXTOS_ID_INC1 !== null && selectedItem.TEXTOS_ID_INC1 !== 0"
                          @click="openResourceWithParam('texts', selectedItem.TEXTOS_ID_INC1)"/>
                <input type="text" v-bind:value="getTranslation(selectedItem.responses.TEXTOS_EST_INC1)"
                disabled class="form-control" />
                <searchtexts class="pl-2" idModal="mdlSearchTextResponse_INC1"
                  v-on:selected="onSelectedTextResponse($event, 1)">
                </searchtexts>
              </div>
              <span class="validation-error">{{ errors[0] }}</span>
            </ValidationProvider>
          </div>
          <div>
            <label>Respuesta erronea 2</label>
            <div class="col-md-12 d-inline-flex align-items-center p-0 m-0">
              <i class="zmdi zmdi-link pointer pr-2 text-primary"
                        v-if="selectedItem.TEXTOS_ID_INC2 !== null && selectedItem.TEXTOS_ID_INC2 !== 0"
                        @click="openResourceWithParam('texts', selectedItem.TEXTOS_ID_INC2)"/>
              <i class="zmdi zmdi-close-circle pointer pr-2 text-danger" v-if="selectedItem.TEXTOS_ID_INC2 !== 0" @click="cleanIncText(2)" />
               <input type="text" v-bind:value="getTranslation(selectedItem.responses.TEXTOS_EST_INC2)"
              disabled class="form-control" />
              <searchtexts class="pl-2" idModal="mdlSearchTextResponse_INC2"
                v-on:selected="onSelectedTextResponse($event, 2)">
              </searchtexts>
            </div>
          </div>
          <div>
            <label>Respuesta erronea 3</label>
            <div class="col-md-12 d-inline-flex align-items-center p-0 m-0">
              <i class="zmdi zmdi-link pointer pr-2 text-primary"
                        v-if="selectedItem.TEXTOS_ID_INC3 !== null && selectedItem.TEXTOS_ID_INC3 !== 0"
                        @click="openResourceWithParam('texts', selectedItem.TEXTOS_ID_INC3)"/>
              <i class="zmdi zmdi-close-circle pointer pr-2 text-danger" v-if="selectedItem.TEXTOS_ID_INC3 !== 0" @click="cleanIncText(3)" />
              <input type="text" v-bind:value="getTranslation(selectedItem.responses.TEXTOS_EST_INC3)"
              disabled class="form-control" />
              <searchtexts class="pl-2" idModal="mdlSearchTextResponse_INC3"
                v-on:selected="onSelectedTextResponse($event, 3)">
              </searchtexts>
            </div>
          </div>
          <div>
            <label>Respuesta erronea 4</label>
            <div class="col-md-12 d-inline-flex align-items-center p-0 m-0">
              <i class="zmdi zmdi-link pointer pr-2 text-primary"
                        v-if="selectedItem.TEXTOS_ID_INC4 !== null && selectedItem.TEXTOS_ID_INC4 !== 0"
                        @click="openResourceWithParam('texts', selectedItem.TEXTOS_ID_INC4)"/>
              <i class="zmdi zmdi-close-circle pointer pr-2 text-danger" v-if="selectedItem.TEXTOS_ID_INC4 !== 0" @click="cleanIncText(4)" />
              <input type="text" v-bind:value="getTranslation(selectedItem.responses.TEXTOS_EST_INC4)"
              disabled class="form-control" />
              <searchtexts class="pl-2" idModal="mdlSearchTextResponse_INC4"
                v-on:selected="onSelectedTextResponse($event, 4)">
              </searchtexts>
            </div>
          </div>
        </b-col>

      </b-row>

      <hr>

       <b-row>
        <b-col  style="text-align:center">
          <strong>Operaciones del ejercicio</strong>
          <b-button v-if="arrayEleOperation.length > 0" @click="removeArrayEleOperation()" class="btn btn-danger ml-2" size="sm">-</b-button>
          <b-button @click="addArrayEleOperation()" class="btn btn-primary ml-2" size="sm">+</b-button>
        </b-col>
      </b-row>

      <div>
        <div v-for="(operation, index) in arrayEleOperation" v-bind:key="index">
            <b-row class="justify-content-md-center" style="margin-bottom: 10px">
              <b-col col md="6">
                <div class="custom-control custom-checkbox">
                  Tipo<select class="form-control" v-model="arrayEleOperation[index].TIPO"
                  v-on:change="changeTipo(index)">
                    <option value="A">Problema Aritmetico Simple</option>
                    <option value="F">Problema de Fórmula</option>
                  </select>
                </div>
              </b-col>
              <b-col col md="6">
                Enunciado <span  v-text="arrayEleOperation[index].TIPO==='A' ? 'Simple' : (arrayEleOperation[index].TIPO==='F' ? 'Fórmula' : '')"></span>
                <ValidationProvider :rules="{required: true}" v-slot="{ errors }">
                  <div class="col-md-12 d-inline-flex align-items-center p-0 m-0">
                    <i class="zmdi zmdi-link pointer pr-2 text-primary"
                          v-if="arrayEleOperation[index].ENUNCIADO_ID !== null && arrayEleOperation[index].ENUNCIADO_ID !== 0
                          && arrayEleOperation[index].TIPO==='A'"
                          @click="openResourceWithParam('statementsimple', arrayEleOperation[index].ENUNCIADO_ID)"/>
                      <i class="zmdi zmdi-link pointer pr-2 text-primary"
                          v-if="arrayEleOperation[index].ENUNCIADO_ID !== null && arrayEleOperation[index].ENUNCIADO_ID !== 0
                          && arrayEleOperation[index].TIPO==='F'"
                          @click="openResourceWithParam('statementformula', arrayEleOperation[index].ENUNCIADO_ID)"/>
                    <input type="text" v-model="arrayEleOperation[index].ENUNCIADO_TEXTO"
                      disabled class="form-control" />
                      <searchstatementsimple class="pl-2" :idModal="'mdlSearchEnunciadoSimple_' + index" v-show="arrayEleOperation[index].TIPO==='A'"
                        v-on:selected="onSelectedEnunciadoSimple($event, index)">
                      </searchstatementsimple>
                      <searchstatementformula class="pl-2" :idModal="'mdlSearchEnunciadoFormula_' + index" v-show="arrayEleOperation[index].TIPO==='F'"
                        v-on:selected="onSelectedEnunciadoFormula($event, index)">
                      </searchstatementformula>
                  </div>
                  <span class="validation-error">{{ errors[0] }}</span>
                </ValidationProvider>
              </b-col>
            </b-row>
        </div>
      </div>

        <br />
        <label for="Tag">
        <br>
          Etiquetas</label>
            <div>
            <vue-tags-input
              v-model="tag"
              :tags="tags"
              :autocomplete-items="autocompleteItems"
              @tags-changed="update"
            />
          </div>
        <div class="modal-footer">
          <button type="button" @click="save"
          class="btn btn-info btn-round waves-effect">
            Guardar</button>
          <b-button class="btn btn-default btn-round waves-effect" block
          @click="$bvModal.hide('info-modal')">Cerrar</b-button>
        </div>
      </ValidationObserver>
    </div>
  </b-modal>
</div>
</template>

<script>
import { ValidationProvider, ValidationObserver, extend } from 'vee-validate';
import { required } from 'vee-validate/dist/rules';
import VueTagsInput from '@johmun/vue-tags-input';
import searchtexts from '../texts/SearchTexts.vue';
import searchimages from '../images/SearchImages.vue';
import searchaudios from '../audios/SearchAudios.vue';
import searchstatementformula from './SearchStatementFormula.vue';
import searchstatementsimple from './SearchStatementSimples.vue';
import ResourceSearchs from '../../../components/panel/ResourceSearchs.vue';
import searchMixin from '../../../mixins/search';
import translationMixin from '../../../mixins/translation';

extend('required', {
  ...required,
  message: 'Campo obligatorio.',
});

export default {
  components: {
    VueTagsInput,
    searchtexts,
    searchimages,
    searchaudios,
    searchstatementformula,
    searchstatementsimple,
    ResourceSearchs,
    ValidationProvider,
    ValidationObserver,
  },
  name: 'gridStatementMultiple',
  mixins: [searchMixin, translationMixin],
  data() {
    return {
      perPage: 20,
      rows: 0,
      currentPage: 1,
      selectedNumOpertion: 1,
      arrayEleOperation: [],
      nopertations: [
        { value: 1 },
        { value: 2 },
        { value: 3 },
        { value: 4 },
        { value: 5 },
        { value: 6 },
        { value: 7 },
        { value: 8 },
        { value: 9 },
        { value: 10 },
      ],
      fields: [
        { key: 'NOMBRE', label: 'Nombre' },
        { key: 'COUNT_SUBPROBLEMAS', label: 'Número subproblemas' }, // TODO: Count number of subproblems related to this item
        { key: 'actions', label: 'Acciones', tdClass: 'tdActionClass' },
      ],
      resources: [],
      selectedItem: {
        ID: null,
        NOMBRE: null, // Nombre descriptivo para buscar
        TEXTOS_ID_ENUNCIADO: null, // Enlace al enunciado
        TEXTOS_ID_COR: null, // Enlace al texto de la respuesta correcta
        TEXTOS_ID_INC1: null, // Enlace al texto de la respuesta incorrecta
        TEXTOS_ID_INC2: 0, // Enlace al texto de la respuesta incorrecta
        TEXTOS_ID_INC3: 0, // Enlace al texto de la respuesta incorrecta
        TEXTOS_ID_INC4: 0, // Enlace al texto de la respuesta incorrecta
        AUDIOS_ID: 0, // Enlace al audio que acompaña al enunciado, 0 si no tiene
        IMAGENES_ID: 0, // Enlace a la imagen que acompaña al enunciado, 0 si no tiene
        text: { // Used for display
          TEXTO_ENUNCIADO: [],
          AUDIO_ENUNCIADO: [],
          IMAGEN_ENUNCIADO: [],
        },
        responses: { // Used for display
          TEXTOS_EST_COR: [],
          TEXTOS_EST_INC1: [],
          TEXTOS_EST_INC2: [],
          TEXTOS_EST_INC3: [],
          TEXTOS_EST_INC4: [],
        },
      },
      infoModal: {
        id: 'info-modal',
        title: '',
        content: '',
      },
      tag: '',
      taglist: '',
      tags: [],
      newTags: [],
      newTags2: [],
      tagslist: [],
      autocompleteItems: [],
    };
  },
  methods: {
    removeArrayEleOperation() {
      this.arrayEleOperation.pop();
    },
    addArrayEleOperation() {
      this.arrayEleOperation.push({
        POSICION: this.arrayEleOperation.length + 1,
        TIPO: 'A', // Tipo de susbproblema: A aritmético simple F fórmula
        ENUNCIADO_ID: null, // Enlace al enunciado simple o de formula, dependiendo del tipo
        ENUNCIADO_TEXTO: null,
      });
    },
    changeTipo(index) {
      this.arrayEleOperation[index].ENUNCIADO_ID = null;
      this.arrayEleOperation[index].ENUNCIADO_TEXTO = null;
    },
    /**
    * @method onSelectedText
    * @description Al seleccionar un texto
    */
    onSelectedTextEnunciado(itemSelected) {
      this.selectedItem.TEXTOS_ID_ENUNCIADO = itemSelected.ID;
      this.selectedItem.text.TEXTO_ENUNCIADO = itemSelected.TEXTOS;
      this.$root.$emit('bv::hide::modal', 'mdlSearchTextEnunciado');
    },
    /**
    * @method cleanIncText
    * @description Limpia los textos incorrectos
    */
    cleanIncText(id) {
      switch (id) {
        case 2:
          // Respuesta Erronea 2
          this.selectedItem.TEXTOS_ID_INC2 = 0;
          this.selectedItem.responses.TEXTOS_EST_INC2 = [];
          break;
        case 3:
          // Respuesta Erronea 3
          this.selectedItem.TEXTOS_ID_INC3 = 0;
          this.selectedItem.responses.TEXTOS_EST_INC3 = [];
          break;
        case 4:
          // Respuesta Erronea 4
          this.selectedItem.TEXTOS_ID_INC4 = 0;
          this.selectedItem.responses.TEXTOS_EST_INC4 = [];
          break;
        default:
          break;
      }
    },
    onSelectedTextResponse(itemSelected, id) {
      switch (id) {
        case 0:
          // Respuesta Correcta
          this.selectedItem.TEXTOS_ID_COR = itemSelected.ID;
          this.selectedItem.responses.TEXTOS_EST_COR = itemSelected.TEXTOS;
          this.$root.$emit('bv::hide::modal', 'mdlSearchTextResponse_Correcta');
          break;
        case 1:
          // Respuesta Erronea 1
          this.selectedItem.TEXTOS_ID_INC1 = itemSelected.ID;
          this.selectedItem.responses.TEXTOS_EST_INC1 = itemSelected.TEXTOS;
          this.$root.$emit('bv::hide::modal', 'mdlSearchTextResponse_INC1');
          break;
        case 2:
          // Respuesta Erronea 2
          this.selectedItem.TEXTOS_ID_INC2 = itemSelected.ID;
          this.selectedItem.responses.TEXTOS_EST_INC2 = itemSelected.TEXTOS;
          this.$root.$emit('bv::hide::modal', 'mdlSearchTextResponse_INC2');
          break;
        case 3:
          // Respuesta Erronea 3
          this.selectedItem.TEXTOS_ID_INC3 = itemSelected.ID;
          this.selectedItem.responses.TEXTOS_EST_INC3 = itemSelected.TEXTOS;
          this.$root.$emit('bv::hide::modal', 'mdlSearchTextResponse_INC3');
          break;
        case 4:
          // Respuesta Erronea 4
          this.selectedItem.TEXTOS_ID_INC4 = itemSelected.ID;
          this.selectedItem.responses.TEXTOS_EST_INC4 = itemSelected.TEXTOS;
          this.$root.$emit('bv::hide::modal', 'mdlSearchTextResponse_INC4');
          break;
        default:
          break;
      }
    },
    /**
    * @method cleanAudio
    * @description Limpia el audio
    */
    cleanAudio() {
      this.selectedItem.AUDIOS_ID = 0;
      this.selectedItem.text.AUDIO_ENUNCIADO = [];
    },
    /**
    * @method onSelectedAudio
    * @description Al seleccionar un audio
    */
    onSelectedAudio(itemSelected) {
      this.selectedItem.AUDIOS_ID = itemSelected.ID;
      this.selectedItem.text.AUDIO_ENUNCIADO = itemSelected.FICHERO;
      this.$root.$emit('bv::hide::modal', 'mdlSearchAudio');
    },
    /**
    * @method cleanImage
    * @description Limpia la imagen
    */
    cleanImage() {
      this.selectedItem.IMAGENES_ID = 0;
      this.selectedItem.text.IMAGEN_ENUNCIADO = [];
    },
    /**
    * @method onSelectedImage
    * @description Al seleccionar una imagen
    */
    onSelectedImage(itemSelected) {
      this.selectedItem.IMAGENES_ID = itemSelected.ID;
      this.selectedItem.text.IMAGEN_ENUNCIADO = itemSelected.FICHERO;
      this.$root.$emit('bv::hide::modal', 'mdlSearchImageEnunciado');
    },
    onSelectedEnunciadoFormula(itemSelected, index) {
      this.arrayEleOperation[index].ENUNCIADO_ID = itemSelected.ID;
      this.arrayEleOperation[index].ENUNCIADO_TEXTO = itemSelected.NOMBRE;
      this.$root.$emit('bv::hide::modal', `mdlSearchEnunciadoFormula_${index}`);
    },
    onSelectedEnunciadoSimple(itemSelected, index) {
      this.arrayEleOperation[index].ENUNCIADO_ID = itemSelected.ID;
      this.arrayEleOperation[index].ENUNCIADO_TEXTO = itemSelected.NOMBRE;
      this.$root.$emit('bv::hide::modal', `mdlSearchEnunciadoSimple_${index}`);
    },
    onNew() {
      this.limpiar();
      this.infoModal.title = 'Nuevo enunciado multiple';
      this.$root.$emit('bv::show::modal', this.infoModal.id);
    },
    limpiar() {
      this.selectedItem.ID = null;
      this.selectedItem.NOMBRE = null;
      this.selectedItem.TEXTOS_ID_ENUNCIADO = null;
      this.selectedItem.TEXTOS_ID_COR = null;
      this.selectedItem.TEXTOS_ID_INC1 = null;
      this.selectedItem.TEXTOS_ID_INC2 = 0;
      this.selectedItem.TEXTOS_ID_INC3 = 0;
      this.selectedItem.TEXTOS_ID_INC4 = 0;
      this.selectedItem.AUDIOS_ID = 0;
      this.selectedItem.IMAGENES_ID = 0;
      // Text to show on forms
      this.selectedItem.text.TEXTO_ENUNCIADO = [];
      this.selectedItem.text.AUDIO_ENUNCIADO = [];
      this.selectedItem.text.IMAGEN_ENUNCIADO = [];
      this.selectedItem.responses.TEXTOS_EST_COR = [];
      this.selectedItem.responses.TEXTOS_EST_INC1 = [];
      this.selectedItem.responses.TEXTOS_EST_INC2 = [];
      this.selectedItem.responses.TEXTOS_EST_INC3 = [];
      this.selectedItem.responses.TEXTOS_EST_INC4 = [];
      this.tag = '';
      this.tags = [];
    },
    async ondelete(item) {
      const confirmation = await this.$bvModal.msgBoxConfirm('Esta a punto de eliminar un registro ¿Esta seguro?');
      if (confirmation) {
        /** Elimino los tags asociados */
        const url = `Tagsstatementmultiple/deleteTags/${item.ID}`;
        this.axios.get(url);

        this.loading = true;
        const response = await this.axios.post('statementmultiple/delete', { ID: item.ID });
        if (response.data.status === 'success') {
          this.loading = false;
          this.$toasted.show('Se elimino el registro seleccionado.', { theme: 'outline', type: 'success', duration: 5000 });
          this.getPostData();
        } else {
          this.loading = false;
          this.$toasted.show(response.data.message, { theme: 'outline', type: 'error', duration: 5000 });
        }
      }
    },
    async info(item, index, button) {
      this.infoModal.title = 'Editar Enunciado Multipe';
      this.loading = true;
      try {
        const response = await this.axios.get('statementmultiple/getmultiplestatement', {
          params: {
            id: item.ID,
          },
        });
        this.selectedItem = response.data.content;
        this.selectedNumOpertion = response.data.elements.length;
        this.arrayEleOperation = [];
        response.data.elements.forEach((element) => {
          this.arrayEleOperation.push({
            POSICION: element.POSICION,
            ENUNCIADO_ID: element.ENUNCIADO_ID,
            TIPO: element.TIPO,
            ENUNCIADO_TEXTO: element.ENUNCIADO_TEXTO,
          });
        });
      } catch (e) {
        this.$toasted.show('Ocurrió un error al leer el contenido', { type: 'warning' });
      }
      /* this.infoModal.content = JSON.stringify(item, null, 2);
      this.selectedItem.ID = item.ID;
      this.selectedItem.NOMBRE = item.NOMBRE;
      this.selectedItem.TEXTOS_ID_ENUNCIADO = item.TEXTOS_ID_ENUNCIADO;
      this.selectedItem.TEXTOS_ID_COR = item.TEXTOS_ID_COR;
      this.selectedItem.TEXTOS_ID_INC1 = item.TEXTOS_ID_INC1;
      this.selectedItem.TEXTOS_ID_INC2 = item.TEXTOS_ID_INC2;
      this.selectedItem.TEXTOS_ID_INC3 = item.TEXTOS_ID_INC3;
      this.selectedItem.TEXTOS_ID_INC4 = item.TEXTOS_ID_INC4;
      this.selectedItem.AUDIOS_ID = item.AUDIOS_ID;
      this.selectedItem.IMAGENES_ID = item.IMAGENES_ID; */
      this.getExistingTags(item.ID);
      this.$root.$emit('bv::show::modal', this.infoModal.id, button);
    },
    async save() {
      this.$refs.formValidation.validate().then(async (success) => {
        if (!success) {
          return;
        }

        this.loading = true;
        // Iterar sobre arrayEleOperation
        const NUM_ELEMENTOS = parseInt(this.arrayEleOperation.length, 10);
        const elemntsoperation = [];
        this.arrayEleOperation.forEach((element) => {
          if (element.POSICION <= NUM_ELEMENTOS) {
            elemntsoperation.push({
              // ID: element.ID,
              POSICION: element.POSICION,
              TIPO: element.TIPO,
              ENUNCIADO_ID: element.ENUNCIADO_ID,
              ENUNCIADOS_MULTIPLES_ID: -1,
            });
          }
        });
        const unitData = {
          ID: this.selectedItem.ID || -1,
          NOMBRE: this.selectedItem.NOMBRE,
          TEXTOS_ID_ENUNCIADO: this.selectedItem.TEXTOS_ID_ENUNCIADO,
          TEXTOS_ID_COR: this.selectedItem.TEXTOS_ID_COR,
          TEXTOS_ID_INC1: this.selectedItem.TEXTOS_ID_INC1,
          TEXTOS_ID_INC2: this.selectedItem.TEXTOS_ID_INC2,
          TEXTOS_ID_INC3: this.selectedItem.TEXTOS_ID_INC3,
          TEXTOS_ID_INC4: this.selectedItem.TEXTOS_ID_INC4,
          AUDIOS_ID: this.selectedItem.AUDIOS_ID,
          IMAGENES_ID: this.selectedItem.IMAGENES_ID,
          ELEMENTOS: elemntsoperation,
        };
        try {
          const response = await this.axios.post('statementmultiple/store', unitData);
          if (response.data.status === 'success') {
            // Solo si esta creando agrego el evento
            if (this.selectedItem.ID === -1 || this.selectedItem.ID === null) {
              const bc = new BroadcastChannel('new_resource_statements_multiple');
              bc.postMessage({
                ID: response.data.id,
                NOMBRE: this.selectedItem.NOMBRE,
              });
            }

            const url = `Tagsstatementmultiple/deleteTags/${response.data.id}`;
            const url2 = 'Tagsstatementmultiple/saveTag';

            this.axios.get(url);
            this.newTags.forEach((a) => {
              this.axios.get(`Tags/findTagByName/${a.text}`,
                { name: a.text }).then((resp) => {
                if (resp.data.status === 'success') {
                  this.axios.post(url2, { id: resp.data.id, idtexto: response.data.id });
                } else {
                  this.axios.post(url2, { id: a.key, idtexto: response.data.id });
                }
              });
            });

            this.$toasted.show('Los datos se guardaron satisfactoriamente.', { theme: 'outline', type: 'success', duration: 5000 });
            this.$root.$emit('bv::hide::modal', this.infoModal.id);
            this.limpiar();

            // Auto close if coming from a create event
            if (this.bAutoClose) {
              window.open('', '_self').close();
            }

            await this.getPostData();
          } else {
            this.$toasted.show(response.data.message, { theme: 'outline', type: 'error', duration: 5000 });
          }
          this.loading = false;
        } catch (e) {
          const resp = e;
          if (!resp.body.Ok) {
            this.$toasted.show(resp.body.Message, { theme: 'outline', type: 'error', duration: 5000 });
          }
          this.loading = false;
        }
      });
    },
    async getContents() {
      this.loading = true;

      try {
        const response = await this.axios.get('statementmultiple');
        this.resources = response.data;
        this.loading = false;
      } catch (e) {
        this.loading = false;
      }
    },
    async getPostData() {
      this.loading = true;
      try {
        const response = await this.axios.get('statementmultiple', {
          params: {
            currentPage: this.currentPage,
            size: this.perPage,
            newTags: this.newTags2,
            resourcetosearch: this.$refs.searchcomponent.resoursetosearch,
          },
        });
        this.rows = response.data.rows;
        this.resources = Object.keys(response.data.results).map(k => response.data.results[k]);
        this.loading = false;
      } catch (e) {
        this.loading = false;
      }
    },
    updatelist(newTags) {
      this.newTags2 = newTags;
      this.getPostData();
    },
    listTags() {
      const url = 'Tags';
      const datos = [];
      this.axios.get(url).then((res) => {
        res.data.forEach((a) => {
          datos.push({ key: a.ID, text: a.NOMBRE });
        });
        this.tagslist = datos;
      })
        .catch((error) => {
          console.error(error);
        });
      this.loading = false;
    },
    initItems() {
      const url = 'Tags';
      const datos = [];

      this.axios.get(url).then((res) => {
        res.data.forEach((a) => {
          datos.push({ text: a.NOMBRE, key: a.ID });
        });
        this.autocompleteItems = datos;
      })
        .catch((error) => {
          console.error(error);
        });
      this.loading = false;
    },
    update(newTags) {
      this.tags = newTags;
      this.newTags = newTags;
    },
    async getExistingTags(idtxt) {
      const url = `Tagsstatementmultiple/findByStatementMultiple/${idtxt}`;
      const datos = [];
      this.loading = true;

      try {
        this.axios.get(url).then((res) => {
          res.data.forEach((a) => {
            datos.push({ text: a.NOMBRE, key: a.ID });
          });
          this.tags = datos;
        })
          .catch((error) => {
            console.error(error);
          });
        this.loading = false;
      } catch (e) {
        console.log(e);
        this.loading = false;
      }
    },
  },
  async mounted() {
    await this.getPostData();
    this.initItems();
    this.listTags();

    // Open create modal automatically
    const self = this;
    const bc = new BroadcastChannel('new_resource_statements_multiple_open');
    bc.onmessage = () => {
      self.bAutoClose = true;
      self.onNew();
    };

    if (this.$route.params.id != null) {
      const item = {
        ID: this.$route.params.id,
      };
      this.info(item, null, null);
    }
  },
  watch: {
    currentPage: {
      handler() {
        this.getPostData().catch((error) => {
          console.error(error);
        });
      },
    },
  },
};
</script>
<style>
  .tdActionClass{
    width: 180px;
    text-align: center
  }
</style>
